module.exports = __webpack_public_path__ + "img/comment.249a5896.png";